import { getTrendingArtists } from 'api/artists'
import { useQuery } from 'react-query'

export function useTrendingArtists() {
  return useQuery({
    queryKey: ['trending-artists'],
    queryFn: async () => {
      const artists = await getTrendingArtists()
      if (!artists) return []
      return artists.slice(0, 4)
    },
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
